module.exports = __webpack_public_path__ + "static/assets/8917917c3aa0dbed3a17f1632e602145.gif";